import { TableCell, styled } from '@mui/material';

export const StyledTableCell = styled(TableCell)`
  border: 0;
  vertical-align: middle;
`;

/**
 * The quote dialog's surface. Dressed as a panel — the same white card, hairline
 * border and radius as everything else on the shipment page — rather than the
 * hardcoded black 1px border it used to carry.
 */
export const quoteModalSx = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 800,
  width: { xs: 'calc(100% - 32px)', sm: '80%' },
  bgcolor: 'background.paper',
  border: 1,
  borderColor: 'v4.border',
  borderRadius: 2,
  boxShadow: 8,
  p: 3,
};

export const quoteHeadingSx = {
  fontSize: '16px',
  fontWeight: 700,
  textAlign: 'center' as const,
  pb: 2,
};

export const quoteColumnHeaderSx = {
  fontSize: '11px',
  fontWeight: 600,
  color: 'text.secondary',
  textTransform: 'uppercase' as const,
  letterSpacing: '0.04em',
};

export const quoteFooterSx = {
  display: 'flex',
  justifyContent: 'flex-end',
  pt: 2.5,
};
